/**
 * The switch for the PostHog *browser* SDK — `posthog.init`, autocapture,
 * session replay — and for the client-side error tracking that rides with it
 * (`capturePostHogError` → `pubsubPublishPostHogException` →
 * `trackPostHogExceptionAction`). Nothing else gates those: no VERCEL_ENV, no
 * NODE_ENV, no per-feature flag.
 *
 * It is deliberately NOT the gate for the custom analytics events published
 * through `pubsubPublishPostHogEvent` / `trackPostHogEventAction`. Those keep
 * their `VERCEL_ENV === 'production'` gate so a preview deploy or a dev machine
 * can never write org_created / plan_purchased / payment_successful into the
 * funnels the business reads. Exceptions take the opposite trade on purpose:
 * they group by error type and message rather than by person, a failure raised
 * on a preview is still a real failure, and error tracking has to be
 * exercisable outside production — so it follows this flag instead.
 *
 * In production both are on (this flag MUST be true there, or the browser SDK
 * never initialises); outside production only the SDK and error tracking are.
 *
 * `NEXT_PUBLIC_` means the value is inlined into the server AND browser bundles
 * at build time, so this one constant reads correctly from a server layout and
 * from a client component without being passed down as a prop.
 */
export const IS_POSTHOG_ENABLED = process.env.NEXT_PUBLIC_POSTHOG_ERROR_TRACKING_LOCAL === 'true';
